import apiClient from './client';
import { API_ENDPOINTS } from './config';

// Filter types for dashboard
export type DashboardFilterType =
	| 'ALL'
	| 'TODAY'
	| 'THIS_WEEK'
	| 'MONTH_TO_DATE'
	| 'YEAR_TO_DATE'
	| 'CUSTOM';

// Top provider in dashboard response
export interface TopProvider {
	id: number;
	name: string;
	businessName: string;
	totalRevenue: number;
	totalAppointments: number;
	averageRating: number;
}

// Dashboard API response
export interface DashboardResponse {
	filterType: DashboardFilterType;
	periodStart: string;
	periodEnd: string;
	totalAppointments: number;
	totalRevenue: number;
	totalCustomers: number;
	totalProviders: number;
	topProviders: TopProvider[];
}

// Dashboard API request params
export interface DashboardParams {
	filter: DashboardFilterType;
	startDate?: string; // For CUSTOM filter
	endDate?: string; // For CUSTOM filter
}

// Dashboard API methods
export const dashboardApi = {
	// Get dashboard stats
	getStats: async (params: DashboardParams): Promise<DashboardResponse> => {
		const queryParams = new URLSearchParams({
			filter: params.filter,
		});

		if (params.filter === 'CUSTOM' && params.startDate && params.endDate) {
			queryParams.append('startDate', params.startDate);
			queryParams.append('endDate', params.endDate);
		}

		return apiClient.get<DashboardResponse>(
			`${API_ENDPOINTS.DASHBOARD}?${queryParams.toString()}`
		);
	},
};
